import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import localeMessages from '../locales/player';
import { FormattedMessage, injectIntl } from 'react-intl';
import Logger from '../functions/logging';
import { getRowAssets } from '../functions/helpers';
import PageLoader from '../components/global/PageLoader';
import { receiveVideos, setAppleTVVideos, setEnvironment, saveProfilePictureNumber } from '../redux/actions/SVOD';

import HomePage from '../components/svod/home-page';
import CuratedPage from '../components/svod/peacock/curated-page';
import ShowPage from '../components/svod/show-page';
import Watchlist from '../components/svod/watch-list';
import WatchPage from '../components/svod/watch-page';
import AppleTVPlusPage from '../components/svod/AppleTVPlusPage';
import AppleTransactionalPage from '../components/svod/AppleTransactionalPage';
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";

import SVODStatus from '../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../analytics/analytics-events/constants';


class SVOD extends Component {
	constructor(props) {
		super(props);
		this.scrolling = this.scrolling.bind(this);
		this.setLocation = this.setLocation.bind(this);
		this.state = {};
	}

	componentWillMount() {
		/* Google analytics event - Overall component rendering */
		let svodStatus1 = new SVODStatus(SVODStatusEvent.SVODSESSION_VIEW, '', '', false, false, true, false);
		svodStatus1.gaTracker = this.props.tracker;
		svodStatus1.state = this.state;
		svodStatus1.label = 'loading';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus1);
	}

	componentDidMount() {
		setTimeout(function() {
			let button = document.getElementById("logout");
			if (button) {
				button.style.opacity = 0;
				button.style.zIndex = -1;
			}
		}, 50);
		setTimeout(function() {
			let button = document.getElementById("logout");
			if (button) {
				button.style.opacity = 1;
				button.style.zIndex = 1;
			}
		}, 180000);		

		let profilePictureNumber = Math.floor(Math.random() * 4) + 1;  

		/* Google analytics event */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_TIMER, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		// svodStatus.state = this.state;  // what should state be tracking here?
		svodStatus.timecode = Date.now();
		svodStatus.label = 'start';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		let rows = [];
		let appletvRows = [];
		let appletvAssets = {};
		let { fetchedGroup } = this.props;
		let environment = "amazon";

		if (fetchedGroup && fetchedGroup.svod_env && fetchedGroup.svod_env.rows) {
			/* Google analytics event - Environment Data API Call */
			let svodStatus2 = new SVODStatus(SVODStatusEvent.SVODSESSION_ENVDATA, '', '', false, false, true, false);
			svodStatus2.gaTracker = this.props.tracker;
			svodStatus2.state = this.state;
			svodStatus2.label = 'init';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus2);

			rows = fetchedGroup.svod_env.rows;
			if (fetchedGroup.svod_env.appletv_plus_rows) {
				appletvRows = fetchedGroup.svod_env.appletv_plus_rows;
				appletvAssets = getRowAssets(appletvRows);
			}
			environment = fetchedGroup.svod_env.environment_vendor;
		}

		if (rows.length > 0) {
			/* Google analytics event - Environment Data API Call */
			let svodStatus3 = new SVODStatus(SVODStatusEvent.SVODSESSION_ENVDATA, '', '', false, false, true, false);
			svodStatus3.gaTracker = this.props.tracker;
			svodStatus3.state = this.state;
			svodStatus3.label = 'success';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus3);

		} else {
			/* Google analytics event - Environment Data API Call */
			let svodStatus4 = new SVODStatus(SVODStatusEvent.SVODSESSION_ENVDATA, '', '', false, false, true, false);
			svodStatus4.gaTracker = this.props.tracker;
			svodStatus4.state = this.state;
			svodStatus4.label = 'fail';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus4);
		}

		if (environment === undefined) {
			environment = "netflix";
			console.log("ERROR!! - setting environment to netflix due to fetchedGroup.svod_env.environment_vendor being undefined");
		}

		//  Testing environments:
		// environment = "netflix";
		// environment = "appletv";

		this.props.setEnvironment(environment);

		this.props.receiveVideos(rows);
		if (appletvAssets && appletvRows && appletvRows.length) this.props.setAppleTVVideos(appletvAssets.videos);
		this.props.saveProfilePictureNumber(profilePictureNumber);

		window.addEventListener("beforeunload", (event) => {
			event.preventDefault();
			/* Google analytics event - Environment Data API Call */
			let svodStatus5 = new SVODStatus(SVODStatusEvent.SVODSESSION_EXITPAGE, '', '', false, false, true, false);
			svodStatus5.gaTracker = this.props.tracker;
			svodStatus5.state = this.state;
			svodStatus5.label = 'close browser';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus5);
		});
	}

	componentWillUnmount() {
		this.props.eventHandler({ 
			data: { 
				event_type: "update_environment_response", 
				type: "back_arrow", 
				time: Date.now() 
			}
		});
		// window.alert("unmount"); // hit this on back arrow
	}

	// Setting initial location of rows
	setLocation() {
		let rowIDs = Object.keys(this.props.videos);
		let inView = {};

		for (let i = 1; i < rowIDs.length; i++) {
			let rowName = rowIDs[i].split("_")[1];
			inView[rowName] = false;
		}
		
		/* Google analytics event - Overall component rendering */
		let svodStatus1 = new SVODStatus(SVODStatusEvent.SVODSESSION_VIEW, '', '', false, false, true, false);
		svodStatus1.gaTracker = this.props.tracker;
		svodStatus1.state = this.state;
		svodStatus1.label = 'rendered';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus1);
		
		this.setState({inView});
	}

	scrolling (e) {
		let index = document.querySelector(".index");

		if (index !== null) {
			const windowHeight = index.offsetHeight;
	
			if (this.props.environment === "netflix") {
				if (index.scrollTop !== 0) {
					document.querySelector('#svod-header').setAttribute('style', 'background: #000');
				} else {
					document.querySelector('#svod-header').setAttribute('style', 'background: linear-gradient(#000, transparent)');
				}
			}
	
			
	
	
			// Recording what rows are in view
			let isInViewport = (row) => {
				if (row) {					
					let bounding = row.getBoundingClientRect();
					return (
						bounding.top > 0 &&
						bounding.bottom <= (windowHeight + 50)			
					);
				} else {
					console.log("Not able to track rows in viewport");
				}
			};
	
			let rowIDs = Object.keys(this.props.videos);
				
			if (this.state.inView !== undefined) {
	
				for (let i = 1; i < rowIDs.length; i++) {
					let rowName = `${rowIDs[i].split("_")[0]}`;
					let rowID = `${rowIDs[i].split("_")[1]}`;
					
					let row = document.getElementById(rowID);
					let inView = this.state.inView;
	
					let type;
					switch(rowIDs[i].split("_")[0]) {
						case "Poster": {
							type = "poster";
							break;
						}
						case "Highlight": {
							type = "highlight";
							break;
						}
						default: {
							type = "row";
						}
					}
	
					if (isInViewport(row)) {
						if (this.state.inView[rowID] !== true) {

							this.props.eventHandler({
								data: { event_type: "time_in_view", type: type, action: "start_time", asset_name: rowName, asset_id: rowID, time: Date.now() }
							});
	
							inView = this.state.inView;
							inView[rowID] = true;
							this.setState({ inView });
						}
					} else {
						if (this.state.inView[rowID] === true) {

							this.props.eventHandler({
								data: { event_type: "time_in_view", type: type, action: "end_time", asset_name: rowName, asset_id: rowID, time: Date.now() }
							});
	
							inView = this.state.inView;
							inView[rowID] = false;
							this.setState({ inView });
						}
					}
				}
			} else {
				this.setLocation();
			}
		}
	}
	
	render() {
		// Logger.log(this.constructor.name, "render()", this.props, this.state);

		return (
			<Router>
				<div onScroll={e => this.scrolling(e)} className={`${this.props.environment ? this.props.environment : this.props.fetchedGroup.svod_env.environment_vendor}-svod`} id='parent'>
					<Switch>
						<Route exact path="/study" render={() => <HomePage {...this.props} inView={this.state.inView} />} />
						<Route exact path="/study/curated" render={() => <CuratedPage {...this.props} />} />
						<Route exact path="/study/watchlist" render={() => <Watchlist {...this.props} />} />
						<Route exact path="/study/showpage" render={() => <ShowPage {...this.props} />} />
						<Route exact path="/study/watch" render={() => <WatchPage {...this.props} />} />
						<Route exact path="/study/included-with-apple-tv" render={() => <AppleTVPlusPage {...this.props} />} />
						<Route exact path="/study/transaction" render={() => <AppleTransactionalPage {...this.props} />} />
						{/* <Route component={ errorPage }/> */}
					</Switch>
				</div>
			</Router>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		currentUserLocation: state.currentUser.currentUserLocation,
		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedGroup: state.targetProcess.fetchedGroup,
		fetchedPanel: state.targetProcess.fetchedPanel,
		targetParams: state.targetProcess.targetParams,
		userDisclaimer: state.currentUser.userDisclaimer,
		tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
		globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
		
		environment: state.SVOD.environment,
		videos: state.SVOD.videos,
		appleTVVideos: state.SVOD.appleTVVideos
	};
}

const mapDispatchToProps = (dispatch) => ({
	receiveVideos: (videos) => dispatch(receiveVideos(videos)),
	setAppleTVVideos: (videos) => dispatch(setAppleTVVideos(videos)),
	setEnvironment: (environment) => dispatch(setEnvironment(environment)),
	saveProfilePictureNumber: (profilePictureNumber) => dispatch(saveProfilePictureNumber(profilePictureNumber))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SVOD));


// WEBPACK FOOTER //
// ./src/pages/SVOD.js